/**
 * @generated SignedSource<<c2cb26ff735a6465659945ad46d726c9>>
 * @relayHash cc5f3b4360d88f7e5b6eea984bcb4594
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cc5f3b4360d88f7e5b6eea984bcb4594

import { ConcreteRequest } from 'relay-runtime';
export type PatientRecordExportStatus = "COMPLETED" | "DELIVERING" | "DISCARDED" | "FAILED" | "GENERATING_SUMMARY" | "PACKAGING" | "SUMMARY_READY";
export type ProgressNoteKindFilter = "ADMINISTRATIVE" | "MEDICAL";
export type Ch_requestPatientRecordExportInput = {
  episodeOfCareIds?: ReadonlyArray<string> | null;
  includeTimeWindows: boolean;
  patientId: string;
  period?: DateRangeInput | null;
  progressNoteKind?: ProgressNoteKindFilter | null;
};
export type DateRangeInput = {
  from: any;
  to: any;
};
export type useRequestPatientRecordExportMutation$variables = {
  input: Ch_requestPatientRecordExportInput;
};
export type useRequestPatientRecordExportMutation$data = {
  readonly ch_requestPatientRecordExport: {
    readonly requestPatientRecordExportOutput: {
      readonly requestId: string;
      readonly status: PatientRecordExportStatus;
    } | null;
  };
};
export type useRequestPatientRecordExportMutation = {
  response: useRequestPatientRecordExportMutation$data;
  variables: useRequestPatientRecordExportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_requestPatientRecordExportPayload",
    "kind": "LinkedField",
    "name": "ch_requestPatientRecordExport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RequestPatientRecordExportOutput",
        "kind": "LinkedField",
        "name": "requestPatientRecordExportOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRequestPatientRecordExportMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useRequestPatientRecordExportMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "cc5f3b4360d88f7e5b6eea984bcb4594",
    "metadata": {},
    "name": "useRequestPatientRecordExportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a042c155416106407cc3538eb8b4f055";

export default node;
